import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { parsePlayerPosition, type PlayerPosition } from '../messages/index.ts'
import { rootRoute } from './root.tsx'

// A typed search param and not a store, so the filtered view is linkable and the back
// button works. §4.4, and apps/frontend/docs/pages-players-non-feature.md.

export interface PlayersSearch {
  /** The selected position, or `null` for "all". */
  readonly position: PlayerPosition | null
}

export const playersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.players,
  validateSearch: (search: Record<string, unknown>): PlayersSearch => ({
    position: parsePlayerPosition(search.position),
  }),
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['coach', 'club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/players.tsx')),
})
